<vl-spinner id="application_creation" [show]="spinnerVisible"></vl-spinner>
<ng-container *ngIf="true">
  <mat-dialog-content>
    <mat-stepper #stepper color="primary" [linear]="true" >
      <mat-step label="Setting" [stepControl]="postAppDetailsData">
        <form [formGroup]="postAppDetailsData">
          <div class="row">
            <div class="col-8">

              <mat-form-field appearance="outline">
                <mat-label>App Name</mat-label>
                <input cdkFocusInitial matInput type="text" formControlName="applicationName" placeholder="App Name" (input)="changeAppName($event)" />
                <mat-error class="error-message"
                  *ngIf="postAppDetailsData.get('applicationName')?.hasError('required')">Application name is required!</mat-error>
                <mat-error
                  *ngIf="postAppDetailsData.get('applicationName')?.hasError('minlength')">
                  Application name must be atleast 3 characters.</mat-error>
                <mat-hint class="error-message" *ngIf="isExistedAppName && !isCheckingAppName">Application name already
                  exists!</mat-hint>
                <mat-hint class="text-success"
                  *ngIf="!isExistedAppName && postAppDetailsData.get('applicationName')?.valid && !isCheckingAppName">Application name available.</mat-hint>
                <mat-spinner *ngIf="isCheckingAppName" class="me-3" matSuffix diameter="20" strokeWidth="3"></mat-spinner>
              </mat-form-field>
              <mat-form-field appearance="outline"  class="mt-1">
                <mat-label>Short Description</mat-label>
                <textarea matInput formControlName="applicationDescription" placeholder="Write here..."
                  [maxlength]="80"></textarea>
                <mat-hint>{{ postAppDetailsData.get('applicationDescription')?.value.length }}/80 Characters
                  Max</mat-hint>
                <mat-icon matSuffix matTooltip="App Description">info</mat-icon>
              </mat-form-field>
            </div>
            <div class="col-4">
              <div class="app-icon-container">
                
                <div class="icon-img-container" matRipple (click)="fileInput.click()">
                  <input #fileInput type="file" (change)="onFileSelected($event)" style="display: none;" accept="image/*">
                  <img [src]="imageSrc" class="w-100" alt="">
                  <div class="edit-icon">
                    <mat-icon>edit</mat-icon>
                  </div>
                </div>
                <div class="hint" [class.text-danger]="showImageTypeError">{{showImageTypeError ? "Invalid file type. Please select an image." : "App Icon"}}</div>
              </div>

            </div>
          </div>
        </form>
      </mat-step>
      <mat-step label="Branding">

        <div class="row">
          <div class="col-6">
            <div class="setting-item">
              <form [formGroup]="appThemeGroup">
                <h3 class="title">Theme</h3>
                <mat-form-field appearance="outline">
                  <mat-label>Select Themes</mat-label>
                  <mat-select matNativeControl formControlName="theme" required
                    (selectionChange)="onOptionSelected($event)">
                    <mat-option [value]="'Custom Theme'">Custom Theme</mat-option>
                    <mat-option *ngFor="let fontStyle of fontStyles" [value]="fontStyle">{{ fontStyle.theme_name
                      }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <div>

                </div>
                <h3 class="title">Colors</h3>
                <div class="color-items">
                  <label class="color-item" mat-ripple for="primaryColor">
                    <input type="color" value="#000000" formControlName="primaryColor" id="primaryColor">
                    <div [style.background-color]="isThemesSelected ? primaryColor : getColorValue('primaryColor')"
                      class="color-thumb">

                    </div>
                    <div class="content">
                      <div class="label">Primary Color</div>
                      <div class="color">{{isThemesSelected ? primaryColor : getColorValue('primaryColor')}}</div>
                    </div>
                  </label>

                  <label class="color-item" mat-ripple for="secondaryColor">
                    <input type="color" value="#000000" formControlName="secondaryColor" id="secondaryColor">
                    <div [style.background-color]="isThemesSelected ? secondaryColor : getColorValue('secondaryColor')"
                      class="color-thumb">

                    </div>
                    <div class="content">
                      <div class="label">On Primary</div>
                      <div class="color">{{isThemesSelected ? secondaryColor : getColorValue('secondaryColor')}}</div>
                    </div>
                  </label>



                  <label class="color-item" mat-ripple for="defaultBackgroundColor">
                    <input type="color" value="#000000" formControlName="defaultBackgroundColor"
                      id="defaultBackgroundColor">
                    <div
                      [style.background-color]="isThemesSelected ? backgroundColor : getColorValue('defaultBackgroundColor')"
                      class="color-thumb">

                    </div>
                    <div class="content">
                      <div class="label">Default Background Color</div>
                      <div class="color">{{isThemesSelected ? backgroundColor :
                        getColorValue('defaultBackgroundColor')}}</div>
                    </div>
                  </label>

                  <label class="color-item" mat-ripple for="defaultTextColor">
                    <input type="color" value="#000000" formControlName="defaultTextColor" id="defaultTextColor">
                    <div [style.background-color]="isThemesSelected ? textColor : getColorValue('defaultTextColor')"
                      class="color-thumb">

                    </div>
                    <div class="content">
                      <div class="label">Default Text Color</div>
                      <div class="color">{{isThemesSelected ? textColor : getColorValue('defaultTextColor')}}</div>
                    </div>
                  </label>
                </div>
              </form>
            </div>
          </div>
          <div class="col-6">
            <div class="setting-item">
              <form [formGroup]="postFontData">
                <h3 class="title">Fonts</h3>
                <mat-form-field appearance="outline">
                  <mat-label>Headings</mat-label>
                  <mat-select matNativeControl formControlName="headingFont" required placeholder="Select Heading Font">
                    <mat-option *ngFor="let fontStyle of types" [value]="fontStyle.font_heading">{{
                      fontStyle.font_heading }}</mat-option>
                  </mat-select>
                  <mat-icon matSuffix>info</mat-icon>
                  <mat-hint align="start" class="error-message" *ngIf="!isHeadingFontSelected()">This is required
                    field!</mat-hint>

                </mat-form-field>
                <mat-form-field appearance="outline">

                  <mat-label>Body</mat-label>
                  <mat-select matNativeControl id="textFontFamily" formControlName="bodyFont" required
                    placeholder="Select Body Font">
                    <mat-option *ngFor="let fontStyle of types" [value]="fontStyle.font_body">{{ fontStyle.font_body
                      }}</mat-option>
                  </mat-select>
                  <mat-icon matSuffix>info</mat-icon>
                  <mat-hint slot="start" class="error-message" *ngIf="!isBodyFontSelected()">This is required
                    field!</mat-hint>

                </mat-form-field>
              </form>
            </div>
          </div>
        </div>

      </mat-step>

    </mat-stepper>

  </mat-dialog-content>
  <mat-dialog-actions class="dailog-footer-buttons">

    <button mat-raised-button [mat-dialog-close]="true" (click)="cancelButtonClicked()">Cancel</button>
    <button mat-raised-button color="primary"  [disabled]="isNextDisabled(stepper.selectedIndex)"   (click)="next(stepper)">Next</button>
  </mat-dialog-actions>
</ng-container>
